import { connect } from 'react-redux';
import TaskEntityCard from '../components/TaskEntityCard';

const mapStateToProps = state => ({ task: state.selectedVerifiedPendingTask });

export default connect(mapStateToProps)(TaskEntityCard);
